import { Dialog } from '@mui/material';
import React, { useRef } from 'react';
import { ReactComponent as CloseIcon } from "assets/img/svg/CloseIcon.svg"
import AAutoComplete from '../../../../../views/pages/manage/common/form-fields-mui/AAutoComplete';
import AButton from '../../../../../views/pages/manage/common/form-fields-mui/AButton';
import styles from "../styles.module.scss";
import ALoader from '../../../../../views/pages/manage/common/a-loader';
import ApprovalSettingTable from './ApprovalSettingTable';
import { failureToast } from '../../../../../views/pages/manage/common/utils/methods/toasterFunctions/function';


const labelStyle = {
    fontWeight: 600,
    fontSize: '12px',
    color: '#262626'
}

const AddEditConfigDialog = ({
    open,
    form,
    setForm,
    handleForm,
    dropdownData,
    handleClose,
    createUpdateConfigHandler,
    regionChangeHandler,
    buLoading,
    loading
}) => {

    const { allActiveRegions, businessAreas, allActiveCareers, allActiveRoles } = dropdownData;
    const ref = useRef();

    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="md"
        >
            {loading && <ALoader position="fixed" />}
            <div className='p-3'>
                <div className='d-flex justify-content-between'>
                    <h4>Transfer Configs</h4>
                    <CloseIcon onClick={handleClose} />
                </div>

                <div className={styles['dropdown-container']}>
                    <div className={styles['label']}>1. Basic Details</div>

                    <div className={styles['dropdowns']}>
                        <AAutoComplete
                            label='Region*'
                            labelStyle={labelStyle}
                            items={allActiveRegions}
                            handleChange={regionChangeHandler}
                            currentValue={form?.regions}
                            isShowCount
                        />

                        <AAutoComplete
                            label='Business area*'
                            labelStyle={labelStyle}
                            items={businessAreas}
                            handleChange={(val) => handleForm("businessArea", val)}
                            currentValue={form?.businessArea}
                            isShowCount
                            isLoading={buLoading}
                        />

                        <AAutoComplete
                            label='Career'
                            labelStyle={labelStyle}
                            items={allActiveCareers}
                            handleChange={(val) => handleForm("academicCareer", val)}
                            currentValue={form?.academicCareer}
                            isShowCount
                        />

                    </div>

                </div>

                <div className={styles['dropdown-container']}>
                    <div className='d-flex justify-content-between'>
                        <div className={styles['label']}>2. Approval Setting</div>
                        <AButton
                            variant='outline'
                            size='xs'
                            onClick={() => ref.current.addNewRow()}
                        >
                            Add new
                        </AButton>
                    </div>
                    <ApprovalSettingTable
                        allActiveRoles={allActiveRoles}
                        ref={ref}
                        rows={form?.approvalSettingDTO}
                        setForm={setForm}
                    />


                </div>

                <AButton
                    variant='primary_filled'
                    className='float-right mt-3'
                    onClick={() => {
                        if(ref.current.isTableInEditMode){
                            failureToast("Please save or discard current changes!");
                            return;
                        }
                        createUpdateConfigHandler();
                    }}
                >
                    Save Config
                </AButton>

            </div>
        </Dialog>
    )
}

export default AddEditConfigDialog;